export const selectOption = {
  ordersOption: [
    {
      code: 1.5,
      desc: '1-2'
    },
    {
      code: 3.5,
      desc: '3-4'
    },
    {
      code: 5.5,
      desc: '5-6'
    },
    {
      code: 7.5,
      desc: '7-8'
    },
    {
      code: 9.5,
      desc: '9-10'
    },
    {
      code: 11.5,
      desc: '11-12'
    },
    {
      code: 13.5,
      desc: '13-14'
    },
    {
      code: 15.5,
      desc: '15-16'
    },
    {
      code: 17.5,
      desc: '17-18'
    },
    {
      code: 19.5,
      desc: '19-20'
    },
    {
      code: 0,
      desc: '0'
    },
    {
      code: 20,
      desc: '20+'
    }
  ],
  daysOption: [
    {
      code: 7,
      desc: '7天'
    },
    {
      code: 15,
      desc: '15天'
    },
    {
      code: 30,
      desc: '30天'
    },
    {
      code: 60,
      desc: '60天'
    },
    {
      code: 90,
      desc: '90天'
    },
    {
      code: 180,
      desc: '180天'
    }
  ]
}
export const openTargetPriceConfig = {
  activeDays: undefined,
  dealCount: undefined,
  merchantPrice: '',
  noMerchantPrice: ''
}